<template>
  <NuxtLayout>
    <div class="awards">
      <section class="awards__Header">
        <FlarePicture
          v-if="page.image"
          :src="{
            1920: { src: page.image, width: 1920, height: 795, size: 'both', crop: 'fill', requestLarger: false },
            1440: { src: page.image, width: 1440, height: 596, size: 'both', crop: 'fill', requestLarger: false },
            1024: { src: page.image, width: 1024, height: 424, size: 'both', crop: 'fill', requestLarger: false },
            769: { src: page.image, width: 800, height: 1100, size: 'both', crop: 'fill', requestLarger: false },
          }"
          :style="`color: ${getDominantColor(page.image)}`"
          :alt="page.image.alt"
        />

        <div class="container">
          <h1 v-text="page.title" />
        </div>
      </section>

      <CMSField v-if="page?.content" :data="page.content" />
    </div> 
  </NuxtLayout>
</template>

<script setup>
  defineProps({
    page: {}
  });

  useHead({
    htmlAttrs: {
      class: 'awardsPage',
    },
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_awards.scss');
</style>